<script setup lang="ts">
import IconMaterialSymbolsNorthEastRounded from '~icons/material-symbols/north-east-rounded';

interface Props {
	title: string[];
	cta: string;
}

defineProps<Props>();
const emits = defineEmits<{
	(e: 'openTypeform'): void;
}>();
</script>

<template>
	<section class="relative bg-primary-light-4">
		<NuxtImg
			:src="'/images/about/hexag_500_brokers.png'"
			loading="lazy"
			format="webp"
			class="absolute z-10 hidden h-full w-40 pl-12 md:block"
		/>
		<Container class="relative z-20 py-12">
			<div
				class="flex flex-col items-center justify-center gap-x-11 gap-y-8 md:flex-row"
			>
				<div class="flex w-full justify-center md:w-1/2">
					<NuxtImg
						loading="lazy"
						:src="'/images/about/intersect_image_500_brokers.png'"
						alt="Pilar"
						format="webp"
						quality="85"
						height="320"
						width="618"
						class="object-contain md:max-h-[320px] md:max-w-[618px]"
					/>
				</div>
				<div
					class="flex w-full flex-col items-center justify-center gap-10 md:w-1/2"
				>
					<div
						class="flex flex-col text-center font-matter-sq text-[30px] font-normal leading-[175%] tracking-[-0.56px]"
					>
						<div class="relative inline-block">
							<span class="relative z-10 text-beige">{{ title[0] }}</span>
							<span
								class="absolute inset-0 -left-4 w-[110%] skew-x-[-20deg] bg-primary"
								aria-hidden="true"
							/>
						</div>
						<div>
							<span class="z-10 font-light text-white">{{
								title[1] + '&nbsp;'
							}}</span>
							<span class="relative inline-block">
								<span class="relative z-10 text-white">{{ title[2] }}</span>
								<NuxtImg
									class="absolute inset-1.5 -left-1 w-full"
									format="webp"
									:src="'/images/about/ellipsis.png'"
								/>
							</span>
						</div>
					</div>
					<Button
						variant="beige"
						class="flex max-w-[279px] px-5 py-3 text-base font-semibold text-primary lg:max-w-[321px] lg:px-6 lg:text-lg"
						@click="emits('openTypeform')"
					>
						<span>{{ cta }}</span>
						<IconMaterialSymbolsNorthEastRounded
							class="size-5 fill-primary lg:size-6"
						/>
					</Button>
				</div>
			</div>
		</Container>
	</section>
</template>
